import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import backendAPI from "../services/axiosInstance";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { resetProjects } from "../state/slices/projectSlice";
import { resetEntities } from "../state/slices/entitiesSlice";
import { resetAllMappings } from "../state/slices/mappingSlice";
import { persistor } from "../state/store"
import { resetWorkflows } from "../state/slices/workflowSlice";

const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    try {
      const response = await backendAPI.get("/auth/logout");
      Cookies.remove("authToken");
      Cookies.remove("userId");
      Cookies.remove("username");
      dispatch(resetProjects());
      dispatch(resetWorkflows());
      dispatch(resetEntities());
      dispatch(resetAllMappings());
      await persistor.purge();
      toast.success("You have been logged out!", { autoClose: 2000 });

      if (response.data.logout_url) {
        navigate("/");
      } else {
        navigate("/");
      }
    } catch (error) {
      console.error("Logout error:", error);
      navigate("/");
    }
    Cookies.remove("authToken");
    Cookies.remove("userId");
    Cookies.remove("username");
    dispatch(resetProjects());
    dispatch(resetWorkflows());
    dispatch(resetEntities());
    dispatch(resetAllMappings());
    await persistor.purge();
    navigate("/");
  };

  return handleLogout;
};

export default useLogout;
